import { Pipe, PipeTransform } from '@angular/core';
import { DprActivity } from '@shared/models/dpr';
import { ActivityStream } from '@shared/models/project-setup';

@Pipe({
  name: 'filterActivityStreamsForDisplay',
})
export class FilterActivityStreamsForDisplayPipe implements PipeTransform {
  transform(
    activityStreams: ActivityStream[],
    activites: DprActivity[],
    parallelActivites: DprActivity[],
    streamId?: number
  ): ActivityStream[] {
    return (
      activityStreams?.filter(
        (x) =>
          (!streamId || x.id === streamId) &&
          (x.isActive ||
            this.hasExistingActivites(
              activityStreams,
              activites,
              parallelActivites,
              x.id
            ))
      ) ?? []
    );
  }

  private hasExistingActivites(
    activityStreams: ActivityStream[],
    activites: DprActivity[],
    parallelActivites: DprActivity[],
    streamId: number
  ): boolean {
    const currentActivityStream = activityStreams.find(
      (x) => x.id === streamId
    );

    if (!!currentActivityStream?.parallelActivityType) {
      return !!parallelActivites?.filter(
        (x) =>
          x.parallelActivityType === currentActivityStream?.parallelActivityType
      )?.length;
    }

    return !!activites?.filter(
      (x) =>
        x.parallelActivityType === currentActivityStream?.parallelActivityType
    )?.length;
  }
}
